import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=69582807&scoped=true&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"
import style0 from "./categories.vue?vue&type=style&index=0&id=69582807&lang=scss&scoped=true&"
import style1 from "./categories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69582807",
  null
  
)

component.options.__file = "categories.vue"
export default component.exports